// 会员端「幸运订单 / 新手计划」文案，与 admin 模块一样合并进基础词典。
export default {
  vi: {
    ordTitle: 'Đơn hôm nay',
    ordSubtitle: 'Tiến độ đơn thích & bình luận của bạn hôm nay',
    ordLoading: 'Đang tải...',
    ordProgress: 'Tiến độ hôm nay',
    ordEarnedToday: 'Đã hôm nay',
    ordTargetToday: 'Mục tiêu hôm nay',
    ordList: 'Danh sách đơn',
    ordEmpty: 'Hôm nay bạn chưa nhận đơn nào',
    ordGoTasks: 'Đi làm nhiệm vụ',
    ordPaidOut: 'Đã trả',
    ordPendingLucky: 'Đơn may mắn chờ thanh toán',
    ordBtnProof: 'Xác nhận hoàn thành',
    welcomeBack: 'Chào mừng trở lại, {name}',
    ordHeroIdle: 'Sẵn sàng chưa? Đặt đơn đầu tiên hôm nay',
    ordHeroClaimed: 'Đã đặt đơn. Tải ảnh lên để nhận tiền',
    ordHeroReview: 'Đã gửi! Đơn của bạn đang được xét duyệt',
    ordHeroPaid: 'Đã duyệt! Toàn bộ đơn hôm nay đã được trả',
    flowOne: 'Đã nhận',
    flowTwo: 'Đã gửi',
    flowThree: 'Đã duyệt',
    flowFour: 'Đã trả',
    ordFeatured: 'Nổi bật',
    ordPlace: 'Chạm để đặt đơn',
    ordQueueing: 'Đang xếp đơn',
    ordQueueHint: 'Đang ghép nhiệm vụ phù hợp cho bạn',
    ordKycRequired: 'Vui lòng hoàn tất xác minh danh tính trước khi nhận đơn',
    ordContinueTask: 'Làm tiếp đơn này',
    ordLuckyFirst: 'Thanh toán đơn hàng trước',
    ordNoTask: 'Tạm thời chưa có đơn, vui lòng thử lại sau',
    ordClaimOk: 'Đã nhận đơn, hoàn thành rồi tải ảnh lên nhé',
    ordClaimFailed: 'Đặt đơn thất bại, vui lòng thử lại',
    stClaimed: 'Chưa nộp ảnh',
    stPendingReview: 'Đang chờ duyệt',
    stApproved: 'Đã trả',
    stRejected: 'Từ chối',
    ordSubmitted: 'Nộp lúc',
    ordReviewed: 'Trả lúc',
    luckyBadge: 'Đơn hàng may mắn',
    luckyTitle: 'Đơn hàng may mắn',
    luckyDesc: 'Thanh toán đơn này; sau khi duyệt sẽ hoàn {payout} vào số dư.',
    luckyAmount: 'Số tiền thanh toán',
    luckyPayout: 'Nhận lại sau duyệt',
    luckyPay: 'Thanh toán ngay',
    luckyPaying: 'Đang xử lý...',
    luckyPaid: 'Thanh toán thành công, tiền đã về số dư!',
    luckyPayTitle: 'Thanh toán đơn hàng',
    luckyPayLoading: 'Đang chuẩn bị thanh toán...',
    luckyPayAmountLabel: 'Số tiền thanh toán on-chain',
    luckyPayAmountHint: 'Chuyển đúng số tiền — hệ thống tự nhận diện khi tiền về ví.',
    luckyPayAddressLabel: 'Địa chỉ nhận',
    luckyPayNetwork: 'TRC20',
    luckyPayWaiting: 'Đang chờ xác nhận on-chain...',
    luckyPayUnavailable: 'Thanh toán tạm ngưng, vui lòng thử lại sau',
    luckyPayExpired: 'Phiên thanh toán đã hết hạn, vui lòng bắt đầu lại',
    luckyNeedDeposit: 'Số dư không đủ, vui lòng nạp thêm {need}',
    luckyGoDeposit: 'Nạp tiền',
    luckyPlanTag: 'Chương trình khách mới · Ngày {day}',
    luckyPlanGoal: 'Mục tiêu hôm nay {done}/{limit} · Dự kiến {target}',
    luckyEmpty: 'Chưa có đơn may mắn nào',
    luckyPayFailed: 'Không thể thanh toán, vui lòng thử lại'
  },
  en: {
    ordTitle: 'Today\'s orders',
    ordSubtitle: 'Your like & comment order progress for today',
    ordLoading: 'Loading...',
    ordProgress: 'Today\'s progress',
    ordEarnedToday: 'Earned today',
    ordTargetToday: 'Today\'s target',
    ordList: 'Order list',
    ordEmpty: 'No orders taken today yet',
    ordGoTasks: 'Go to tasks',
    ordPaidOut: 'Paid',
    ordPendingLucky: 'Lucky orders awaiting payment',
    ordBtnProof: 'Confirm completion',
    welcomeBack: 'Welcome back, {name}',
    ordHeroIdle: 'Ready when you are. Place today’s first order',
    ordHeroClaimed: 'Order placed. Upload your screenshot to get paid',
    ordHeroReview: 'Submitted! Your order is being reviewed',
    ordHeroPaid: 'Approved! Today’s orders are all paid out',
    flowOne: 'Requested',
    flowTwo: 'Reviewed',
    flowThree: 'Shipped',
    flowFour: 'Delivered',
    ordFeatured: 'Featured',
    ordPlace: 'Tap to place order',
    ordQueueing: 'Queuing your order',
    ordQueueHint: 'Matching the right task for you',
    ordKycRequired: 'Please complete identity verification before claiming',
    ordContinueTask: 'Continue this order',
    ordLuckyFirst: 'Pay the order first',
    ordNoTask: 'No orders available right now, try again later',
    ordClaimOk: 'Order placed. Finish it and upload your screenshot.',
    ordClaimFailed: 'Could not place the order, please try again',
    stClaimed: 'Proof needed',
    stPendingReview: 'Awaiting review',
    stApproved: 'Paid',
    stRejected: 'Rejected',
    ordSubmitted: 'Submitted',
    ordReviewed: 'Paid at',
    luckyBadge: 'Lucky order',
    luckyTitle: 'Lucky order',
    luckyDesc: 'Pay this order now; after approval, {payout} is credited to your balance.',
    luckyAmount: 'Amount to pay',
    luckyPayout: 'Return after review',
    luckyPay: 'Pay now',
    luckyPaying: 'Processing...',
    luckyPaid: 'Payment received — reward credited!',
    luckyPayTitle: 'Order payment',
    luckyPayLoading: 'Preparing payment...',
    luckyPayAmountLabel: 'On-chain payment amount',
    luckyPayAmountHint: 'Send the exact amount — it is detected automatically once it lands.',
    luckyPayAddressLabel: 'Deposit address',
    luckyPayNetwork: 'TRC20',
    luckyPayWaiting: 'Waiting for on-chain confirmation...',
    luckyPayUnavailable: 'Payments are temporarily unavailable, please try again later',
    luckyPayExpired: 'Payment window expired, please start again',
    luckyNeedDeposit: 'Not enough balance, please top up {need}',
    luckyGoDeposit: 'Top up',
    luckyPlanTag: 'Newbie plan · Day {day}',
    luckyPlanGoal: 'Today {done}/{limit} · Est. {target}',
    luckyEmpty: 'No lucky orders yet',
    luckyPayFailed: 'Payment failed, please try again'
  },
  ko: {
    ordTitle: '오늘의 주문',
    ordSubtitle: '오늘 좋아요·댓글 주문 진행률',
    ordLoading: '불러오는 중...',
    ordProgress: '오늘 진행',
    ordEarnedToday: '오늘 획득',
    ordTargetToday: '오늘 목표',
    ordList: '주문 목록',
    ordEmpty: '오늘 받은 주문이 없습니다',
    ordGoTasks: '任務 하러 가기',
    ordPaidOut: '지급',
    ordPendingLucky: '행운 주문 결제 대기',
    ordBtnProof: '완료 제출',
    welcomeBack: '다시 오신 것을 환영합니다, {name}',
    ordHeroIdle: '시작할 준비가 됐어요. 오늘의 첫 주문을 해보세요',
    ordHeroClaimed: '주문 완료. 증빙 이미지를 올리면 지급돼요',
    ordHeroReview: '접수 완료! 주문을 심사하고 있어요',
    ordHeroPaid: '승인 완료! 오늘의 주문이 모두 지급됐어요',
    flowOne: '접수',
    flowTwo: '제출',
    flowThree: '승인',
    flowFour: '지급',
    ordFeatured: '추천',
    ordPlace: '탭해서 주문하기',
    ordQueueing: '주문 배정 중',
    ordQueueHint: '알맞은 작업을 배정하는 중',
    ordKycRequired: '청구 전에 실명 인증을 완료해 주세요',
    ordContinueTask: '이 주문 이어하기',
    ordLuckyFirst: '주문을 먼저 결제하세요',
    ordNoTask: '지금은 주문이 없습니다. 잠시 후 다시 시도하세요',
    ordClaimOk: '주문 접수 완료. 완료 후 증빙 이미지를 올려주세요.',
    ordClaimFailed: '주문에 실패했습니다. 다시 시도해 주세요',
    stClaimed: '증빙 대기',
    stPendingReview: '심사 대기',
    stApproved: '지급 완료',
    stRejected: '거절',
    ordSubmitted: '제출',
    ordReviewed: '지급',
    luckyBadge: '행운 주문',
    luckyTitle: '행운 주문',
    luckyDesc: '이 주문을 결제하면 심사 후 {payout}이 잔액으로 입금됩니다.',
    luckyAmount: '결제 금액',
    luckyPayout: '심사 후 환급',
    luckyPay: '지금 결제',
    luckyPaying: '처리 중...',
    luckyPaid: '결제 완료! 보상이 입금되었습니다!',
    luckyPayTitle: '주문 결제',
    luckyPayLoading: '결제 준비 중...',
    luckyPayAmountLabel: '온체인 결제 금액',
    luckyPayAmountHint: '정확한 금액을 전송하면 온체인에서 자동 인식됩니다.',
    luckyPayAddressLabel: '수령 주소',
    luckyPayNetwork: 'TRC20',
    luckyPayWaiting: '온체인 확인 대기 중...',
    luckyPayUnavailable: '결제를 일시적으로 이용할 수 없습니다. 잠시 후 다시 시도해 주세요',
    luckyPayExpired: '결제 시간이 만료되었습니다. 다시 시작해 주세요',
    luckyNeedDeposit: '잔액이 부족합니다. {need} 충전이 필요합니다',
    luckyGoDeposit: '충전',
    luckyPlanTag: '신규 플랜 · {day}일차',
    luckyPlanGoal: '오늘 {done}/{limit} · 예상 {target}',
    luckyEmpty: '행운 주문 없음',
    luckyPayFailed: '결제에 실패했습니다. 다시 시도해 주세요'
  },
  ja: {
    ordTitle: '本日の注文',
    ordSubtitle: '本日いいね・コメント注文の進捗',
    ordLoading: '読み込み中...',
    ordProgress: '本日の進捗',
    ordEarnedToday: '本日獲得',
    ordTargetToday: '本日の目標',
    ordList: '注文一覧',
    ordEmpty: '本日受注した注文はまだありません',
    ordGoTasks: 'タスクへ',
    ordPaidOut: '支払済',
    ordPendingLucky: 'ラッキー注文のお支払い待ち',
    ordBtnProof: '完了を提出',
    welcomeBack: 'おかえりなさい、{name}さん',
    ordHeroIdle: 'はじめましょう。本日の最初の注文をどうぞ',
    ordHeroClaimed: '注文済み。画像をアップロードすると支払われます',
    ordHeroReview: '送信完了！注文を審査中です',
    ordHeroPaid: '承認済み！本日の注文はすべて支払いました',
    flowOne: '受注',
    flowTwo: '送信',
    flowThree: '承認',
    flowFour: '支払',
    ordFeatured: 'おすすめ',
    ordPlace: 'タップして注文する',
    ordQueueing: '注文を割り振り中',
    ordQueueHint: 'あなたに合うタスクを割り当て中',
    ordKycRequired: '受注の前に本人確認を完了してください',
    ordContinueTask: 'この注文を続ける',
    ordLuckyFirst: '注文を先にお支払いください',
    ordNoTask: '現在注文できません。しばらくしてからお試しください',
    ordClaimOk: '注文を受け付けました。完了後に画像をアップロードしてください。',
    ordClaimFailed: '注文に失敗しました。もう一度お試しください',
    stClaimed: '画像未提出',
    stPendingReview: '審査待ち',
    stApproved: '支払済',
    stRejected: '拒否',
    ordSubmitted: '提出',
    ordReviewed: '支払',
    luckyBadge: 'ラッキー注文',
    luckyTitle: 'ラッキー注文',
    luckyDesc: 'この注文を決済すると、審査後に {payout} が残高に返還されます。',
    luckyAmount: '支払金額',
    luckyPayout: '審査後に返還',
    luckyPay: '今すぐ決済',
    luckyPaying: '処理中...',
    luckyPaid: '決済完了！報酬が入金されました！',
    luckyPayTitle: '注文決済',
    luckyPayLoading: '決済の準備中...',
    luckyPayAmountLabel: 'オンチェーン支払額',
    luckyPayAmountHint: '正確な金額を送金すると、着金後に自動で認識されます。',
    luckyPayAddressLabel: '受取アドレス',
    luckyPayNetwork: 'TRC20',
    luckyPayWaiting: 'オンチェーン確認待ち...',
    luckyPayUnavailable: '決済は一時的に利用できません。後ほどお試しください',
    luckyPayExpired: '決済時間が切れました。もう一度開始してください',
    luckyNeedDeposit: '残高が不足しています。{need} チャージしてください',
    luckyGoDeposit: 'チャージ',
    luckyPlanTag: '新規プラン · {day}日目',
    luckyPlanGoal: '本日 {done}/{limit} · 見込み {target}',
    luckyEmpty: 'ラッキー注文はありません',
    luckyPayFailed: '決済に失敗しました。もう一度お試しください'
  },
  zh: {
    ordTitle: '今日订单',
    ordSubtitle: '今天点赞/评论订单的完成进度',
    ordLoading: '加载中...',
    ordProgress: '今日进度',
    ordEarnedToday: '今日已赚',
    ordTargetToday: '今日目标',
    ordList: '订单列表',
    ordEmpty: '今天还没有接到订单',
    ordGoTasks: '去做任务',
    ordPaidOut: '已发放',
    ordPendingLucky: '幸运订单待支付',
    ordBtnProof: '提交完成',
    welcomeBack: '欢迎回来，{name}',
    ordHeroIdle: '随时可以开始，下今天的第一单',
    ordHeroClaimed: '已下单，上传截图即可结算',
    ordHeroReview: '已提交，订单正在审核',
    ordHeroPaid: '已通过，今日订单全部到账',
    flowOne: '已接单',
    flowTwo: '已提交',
    flowThree: '已通过',
    flowFour: '已到账',
    ordFeatured: '精选',
    ordPlace: '点击下单',
    ordQueueing: '正在排单',
    ordQueueHint: '正在为你匹配最合适的任务',
    ordKycRequired: '请先完成实名认证，再领取订单',
    ordContinueTask: '继续做这一单',
    ordLuckyFirst: '请先支付订单',
    ordNoTask: '暂时没有可下的单，请稍后再试',
    ordClaimOk: '下单成功，完成后上传截图',
    ordClaimFailed: '下单失败，请重试',
    stClaimed: '待传截图',
    stPendingReview: '待审核',
    stApproved: '已发放',
    stRejected: '已拒绝',
    ordSubmitted: '提交于',
    ordReviewed: '发放于',
    luckyBadge: '幸运订单',
    luckyTitle: '幸运订单',
    luckyDesc: '支付本单，审核通过后返还 {payout} 到余额。',
    luckyAmount: '需垫付',
    luckyPayout: '审核后返还',
    luckyPay: '立即支付',
    luckyPaying: '处理中...',
    luckyPaid: '支付成功，奖励已到账！',
    luckyPayTitle: '订单支付',
    luckyPayLoading: '支付准备中…',
    luckyPayAmountLabel: '链上支付金额',
    luckyPayAmountHint: '请按精确金额转账，到账后系统自动识别放款。',
    luckyPayAddressLabel: '收款地址',
    luckyPayNetwork: 'TRC20',
    luckyPayWaiting: '等待链上确认…',
    luckyPayUnavailable: '支付暂不可用，请稍后再试',
    luckyPayExpired: '支付窗口已过期，请重新发起',
    luckyNeedDeposit: '余额不足，请先充值 {need}',
    luckyGoDeposit: '去充值',
    luckyPlanTag: '新手计划 · 第 {day} 天',
    luckyPlanGoal: '今日 {done}/{limit} · 预计 {target}',
    luckyEmpty: '暂无幸运订单',
    luckyPayFailed: '支付失败，请重试'
  }
};
